module.exports = __webpack_public_path__ + "fonts/icomoon.b7c5e79c.eot";